import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as Storage from "../store/LocalStorage";

import languageEN from "./locales/en/common.json";
import languageAR from "./locales/ar/common.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translations: languageEN,
    },
    ar: {
      translations: languageAR,
    },
  },
  lng: Storage.get("lng") || "en",
  fallbackLng: "en",
  debug: true,
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
  react: {
    useSuspense: false,
    bindI18n: "languageChanged loaded",
    bindStore: "added removed",
    nsMode: "default",
  },
});

export default i18n;
